var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.renderMsgError)?_c('div',[_vm._v("Não foi recebido o id do cliente")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }